import {Injectable} from "@angular/core";
import {MasterOperationModel} from 'web-shared';
import {MasterInputInstructionModel} from "web-shared";

export interface IMenuItem {
  title: string,
  action: (masterOperation: MasterOperationModel, masterInputInstruction: MasterInputInstructionModel) => any
}


@Injectable({providedIn: 'root'})
export class ImeConfig {
  getMasterInputMenuItems(): IMenuItem[] {
    return [];
  }
}
